
Barba.Dispatcher.on("transitionCompleted", function () {

    Text.components.galleries = [];
    const elements = document.querySelectorAll('.gallery');

    elements.forEach(elem => {
        Text.components.galleries.push(
            new Vue({
                el: elem,
                store,
                data: function () {
                    return {
                        slider: null
                    }
                },
                computed: {},
                mounted() {
                    this.initFlickity();
                },
                methods: {
                    initFlickity() {

                        this.slider = new Flickity(this.$refs.slider, {
                            wrapAround: true,
                            lazyLoad: 2,
                            prevNextButtons: false
                        });
                    }
                }
            })
        )
    });

    Text.components.heroSliders = [];
    const elementsHero = document.querySelectorAll('.hero__slider');

    elementsHero.forEach(elem => {
        Text.components.heroSliders.push(
            new Vue({
                el: elem,
                store,
                data: function () {
                    return {
                        slider: null
                    }
                },
                computed: {},
                mounted() {
                    this.initFlickity();
                },
                methods: {
                    initFlickity() {
                        this.slider = new Flickity(this.$refs.slider, {
                            autoPlay: 5000,
                            prevNextButtons: false
                        });
                    },
                }
            })
        )
    })
});